<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 10v4c0 .6.4 1 1 1h3l5 4V5L8 9H5c-.6 0-1 .4-1 1Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path d="M16 9.5a3.5 3.5 0 0 1 0 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <path d="M18.5 7a7 7 0 0 1 0 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity="0.9" />
  </svg>
</template>

